<script>
import proofViewNavigation from "./proof-view-navigation.vue";
import proofViewSideBarLeft from "./proof-view-sidebar-left.vue";
import proofViewSideBarRight from "./proof-view-sidebar-right.vue";
import proofViewZoomTools from "./proof-view-zoom-tools.vue";
import proofViewPagination from "./proof-view-pagination.vue";
import ProofViewNewAnnotations from "./proof-view-new-annotations";
import ProofViewCanvas from "./proof-view-canvas";
import ProofViewComment from "./proof-view-comment";
import FilesToReviewScreen from "./files-to-review-screen.vue";
import {scroller} from "vue-scrollto/src/scrollTo";
import ProofViewTools from "./proof-view-tools";
import reviewAccessDenied from "./reviewAccessDenied";
import { getAnnotationToolTypes, annotationToolKeyForDocType } from "../../utils/annotationTools";
import { PROOF_VIEW_MODES, TYPES_ENUM, DOC_TYPES, ANNOTATION_TYPES, FILE_APPROVAL_STATUS, USER_ACTION, FILE_PROPERTIES } from "../../utils/constants";

const _ = require('lodash');

const { PROOF_OWNER_MODE } = PROOF_VIEW_MODES;
const { VIDEO, IMAGE, HTML, AUDIO, DOCUMENT } = DOC_TYPES;
const { FUNCTION } = TYPES_ENUM;
const { DRAW, POINT } = ANNOTATION_TYPES;
const { APPROVED, APPROVED_WITH_CHANGES, REJECTED_INDIVIDUAL, REJECTED } = FILE_APPROVAL_STATUS;
const { APPROVE, REJECT } = USER_ACTION;
const { APPROVAL_FEEDBACK, REVIEW_ACTION } = FILE_PROPERTIES;
const firstScrollTo = scroller();
const secondScrollTo = scroller();
const FileProcessedEventType = 62;
const MIN_DATE_TIME = "0001-01-01T00:00:00";
const RESET = 'reset';

export default {
  name: 'proofView',
  components: {
    ProofViewTools,
    proofViewNavigation,
    proofViewSideBarLeft,
    proofViewSideBarRight,
    ProofViewCanvas,
    ProofViewNewAnnotations,
    ProofViewComment,
    proofViewZoomTools,
    proofViewPagination,
    FilesToReviewScreen,
    reviewAccessDenied
  },
  props: {
    label: {
      type: String,
      required: true
    },
    mode: {
      type: Number,
      required: true
    },
    accessDenied: {
      type: Boolean
    },
    accessDeniedMessage: {
      type: String
    },
    commentFileApi: {
      type: String,
      required: true
    },
    curUser: {},
    actives: {},
    events: {},
    curApprover: {},
    curAccount: {},
    approverFeedback: {},
    approverSkipped: { type: Boolean, default: false },
    approverPublicId: {},
    viewMode: {
      type: Number,
    },
    isReviewMode: {
      type: Boolean,
      default: true
    },
    isCompareMode: {
      type: Boolean,
      default: false
    },
    topNavBarOffsetHeight: {
      type: Number,
      default: 0
    },
    publicId: {},
    curLang: {},
    curDisplayLang: {},
    showApprovedButton: {},
    curLogo: {},
    proofViewVersion: 'modern',
    changeTrackingSummary: {
      type: Object,
      default: null
    },
    changeTracking: {
      type: Object,
      default: null
    },
  },
  // metaInfo () {
  //   return {
  //     title: 'this is a test title',
  //     meta: [
  //       {
  //         key: 'og:title',
  //         name: 'og:title',
  //         content: 'this is a test value',
  //       },
  //       {
  //         key: 'og:image',
  //         name: 'og:image',
  //         content: this.curLogo,
  //       },
  //     ]
  //   }
  // },
  data() {
    return {
      width: 0,
      menu: true,
      proof: null,
      goToPageInputValue: -1,
      curFile: null,
      isMobile: window.innerWidth < 991,
      isSmallMobileView: window.innerWidth < 576,
      isMouseOver: false,
      showFilesToReviewScreen: true,
      showLeftSidebar: false,
      steps: [
        {
          target: "#review-available-tools",
          label: "review_available_tools",
          params: {
            enableScrolling: false,
          },
          disableOnFileTypes: [AUDIO]
        },
        {
          target: "#review-available-files",
          label: "review_available_files",
          params: {
            enableScrolling: false,
          },
          disableIfSingleFile: true
        },
        {
          target: "#review-canvas",
          label: "review_your_canvas",
          params: {
            enableScrolling: false,
            placement: "bottom",
          },
        },
        {
          target: "#approval-buttons",
          label: "approval_button_group",
          params: {
            enableScrolling: false,
            placement: "bottom",
          },
          disableOnModes: [2],
        },
      ],
      tourCallbacks: {
        onStop: async () => {
          await window.$A.ReviewService.MarkTourCompleted();
          if (this.curApprover) {
            this.$set(this.curApprover, 'completedProductTour', true);
          }
        },
      },
      tourLabels: {},
      isRecording: false,
      colorPerUserId: {},
      curAnnotationType: {
        docTypes: [DOCUMENT, VIDEO, AUDIO, IMAGE, HTML],
        type: POINT,
        title: () => this.getLabel('review_screen_labels', 'anno_single_click'),
        image: "/img/icon-doubleclick.svg",
        cursor: "/img/icon-doubleclick.png",
      },
      proofNavHeight: 0,
      proofToolsHeight: 0,
      proofCommentsWidth: 0,
      proofFilesWidth: 0,
      editingAnnotationId: 0,
      activeEditorAnnotationId: 0,
      isLiveProofView: false,
      liveProofActiveUrl: null,
      liveProofSizeSelected: {
        size: 0,
        label: () => ""
      },
      liveProofPredefinedSizes: [
        {
          size: window.innerWidth < 576 ? window.innerWidth - 30 : 500,
          label: () => this.getLabel('review_screen_labels', "web_x_small")
        },
        {
          size: 576,
          label: () => this.getLabel('review_screen_labels', "web_small")
        },
        {
          size: 768,
          label: () => this.getLabel('review_screen_labels', "web_medium")
        },
        {
          size: 992,
          label: () => this.getLabel('review_screen_labels', "web_large")
        },
        {
          size: 1200,
          label: () => this.getLabel('review_screen_labels', "web_xl")
        },
        {
          size: 1400,
          label: () => this.getLabel('review_screen_labels', "web_xxl")
        },
        {
          size: 1920,
          label: () => this.getLabel('review_screen_labels', "web_xxxl")
        }
      ],
      liveProofCommentsEnabled: true,
      colorPickerColor: "#D44D68",
      drawToolLineWidth: 5,
      followingApprover: null,
      followingTargetId: null,
      isDragEnabled: false,
      isThirdWheelZoomActive: window.innerWidth < 991
    };
  },
  async mounted() {
    this.handleResizeWindow();
    this.$root.$on("player:progress:change", this.updateProgress);
    this.disableContextMenu();
    window.onresize = this.handleResizeWindow();
    this.handleKeyDown();
  },
  methods: {
    viewFile(file) {
      this.curFile = file;
      this.showFilesToReviewScreen = false;
      file.viewed = true;
      const viewed = this.files.filter(f => f.viewed).map(f => f.id);
      this.$A.SaveDataCache("proof_version_id:" + this.curVersionId + "_viewed_files", viewed);

      this.$nextTick(() => {
        const canvasElement = document.querySelector('.canvas-container');
        if (canvasElement) {
          canvasElement.scrollIntoView({ behavior: 'smooth' });
        }
        if (this.$refs.proofCanvas) {
          this.$refs.proofCanvas.reviewFile(file);
        }
      });
    },
    handleFilesToReviewScreenVisibility() {
      this.showFilesToReviewScreen = true;
      this.curFile = null;
    },
    approveFile(file) {
      if (file.approvalFeedback !== APPROVED) {
        this.$set(file, APPROVAL_FEEDBACK, APPROVED);
        this.$set(file, REVIEW_ACTION, APPROVE);
      } else {
        this.$set(file, REVIEW_ACTION, null);
        this.$set(file, APPROVAL_FEEDBACK, REJECTED);
      }
      this.emitApprovalState();
    },

    rejectFile(file) {
      if (file.approvalFeedback !== REJECTED_INDIVIDUAL) {
        this.$set(file, APPROVAL_FEEDBACK, REJECTED_INDIVIDUAL);
        this.$set(file, REVIEW_ACTION, REJECT);
      } else {
        this.$set(file, REVIEW_ACTION, null);
        this.$set(file, APPROVAL_FEEDBACK, REJECTED);
      }
      this.emitApprovalState();
    },

    emitApprovalState() {
      let fileApprovalStatus = [];
      let self = this;

      this.files.forEach(function (f) {
        if (self.allowApproveIndividualFiles) {
          fileApprovalStatus.push({
            fileId: f.id,
            fileName: f.name,
            approved: f.approvalFeedback === APPROVED,
            approvedWithChanges: f.approvalFeedback === APPROVED_WITH_CHANGES,
            rejected: f.approvalFeedback === REJECTED_INDIVIDUAL
          });
        } else {
          fileApprovalStatus.push({
            fileId: f.id,
            fileName: f.name,
            approved: self.mode === APPROVED,
            approvedWithChanges: self.mode === APPROVED_WITH_CHANGES,
            rejected: self.mode === REJECTED
          });
        }
      });

      this.$emit("approverResponded", {
        approvalChoice: this.mode,
        feedBackText: this.feedBackText,
        filesApprovalStatus: fileApprovalStatus,
      });
    },

    loadTourLabels: function () {
      this.tourLabels = {
        'buttonSkip': this.getLabel('tour_labels', 'skip_tour_btn'),
        'buttonPrevious': this.getLabel('tour_labels', 'previous_btn'),
        'buttonNext': this.getLabel('tour_labels', 'next_btn'),
        'buttonStop': this.getLabel('tour_labels', 'finish_btn'),
      };
    },
    handleKeyDown: function () {
      let self = this;
      window.document.addEventListener("keydown", (event) => {
        if (self.isModalOpen || self.activeEditorAnnotationId != 0 || (!self.isReviewMode && !self.isMouseOver) || !self.curFile) return;
        switch (event.key) {
          case "F1":
            self.toggleZoomMode();
            return;
          case "ArrowRight":
            event.preventDefault();
            self.GoToNextPage();
            return;
          case "ArrowLeft":
            event.preventDefault();
            self.GoToPreviousPage();
            return;
          case "ArrowUp":
            if (!window.selectingUserToTag) {
              event.preventDefault();
              self.GoToPreviousProofFile();
            }
            return;
          case "ArrowDown":
            if (!window.selectingUserToTag) {
              event.preventDefault();
              self.GoToNextProofFile();
            }
            return;
          case " ":
            if (!document.activeElement.isContentEditable) {
              const s = this.$refs.proofCanvas.getActiveAudioVideoPlayer();
              self.$refs.proofCanvas.pauseOrResumePlay(s.state != 1);
            }
        }
      });
    },
    updateProgress(progressUpdate) {
      if (this.curFile)
        this.curFile.player.curPlayerTime = progressUpdate;
    },
    viewProofVersion: async function (proofVersionId, proof) {
      if (proofVersionId === 'compare') {
        return this.$emit('on-compare');
      }

      if (_.get(this.proof, 'currentVersion.id') === proofVersionId) {
        return;
      }
      if (proofVersionId === undefined) proofVersionId = 0;

      if(proof) return this.SetCurrentProof(proof, true);

      if (this.curUser !== null) {
        this.SetCurrentProof(await this.$A.ProofService.GetFullProof(
            this.proof.id,
            proofVersionId
        ), true)
      }
      if (this.curApprover !== null) {
        this.SetCurrentProof(await this.$A.ReviewService.GetProofToReview(
          proofVersionId
        ), true);
      }
    },
    getColor: function (userId, luminosity = "dark") {
      if (this.colorPerUserId[userId]) {
        return this.colorPerUserId[userId]
      }
      let seed = Object.keys(this.colorPerUserId).length * 1000;
      let color = this.$randomColor({luminosity: luminosity, seed: seed})
      this.colorPerUserId[userId] = color;
      return color;
    },
    SetCurrentProof(proof, loadFile) {
      let self = this;

      if (loadFile === undefined)
        loadFile = false

      if (_.get(proof, 'message') === "Token Expired") {
        this.$A.AlertUser(
            this.$A.ReviewService.Lang("link-expired"),
            "warning",
            20000
        );
        return;
      }

      const proofId = _.get(proof, 'id', 0)
      if (!proofId) return;

      this.editingCommentId = 0;
      this.editingAnnotationId = 0;
      this.curFile = undefined;
      this.curAnnotation = null;

      let updateCdnLinks = function (cf) {
        if (
            cf.thumbnailFileKey != null &&
            cf.thumbnailFileKey.indexOf("cdn.ashoreapp.com") === -1 &&
            cf.thumbnailFileKey.length > 3 &&
            cf.thumbnailFileKey.indexOf("static") === -1 &&
            !cf.thumbnailFileKey.startsWith("public/icon")
        ) {
          cf.thumbnailFileKey =
              "https://cdn.ashoreapp.com/" + cf.thumbnailFileKey;
        }
        if (
            cf.convertedFileKey != null &&
            cf.convertedFileKey.indexOf("cdn.ashoreapp.com") === -1 &&
            cf.convertedFileKey.length > 3 &&
            cf.convertedFileKey.indexOf("static") === -1 &&
            !cf.convertedFileKey.startsWith("public/icon")
        ) {
          cf.convertedFileKey =
              "https://cdn.ashoreapp.com/" + cf.convertedFileKey;
        }
        if (
            cf.originalFileKey != null &&
            cf.originalFileKey.indexOf("cdn.ashoreapp.com") === -1 &&
            cf.originalFileKey.length > 3 &&
            cf.originalFileKey.indexOf("static") === -1 &&
            !cf.originalFileKey.startsWith("public/icon")
        ) {
          cf.originalFileKey = "https://cdn.ashoreapp.com/" + cf.originalFileKey;
        }

        const isInlineTextType = cf.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || cf.mimeType === 'text/plain';
        if (cf.convertedFileKey === "" && !isInlineTextType) {
          cf.convertedFileKey = cf.originalFileKey;
        }
      };

      const fileConversionProofEvents = _.get(proof, 'proofEvents',[]).filter((event) => event.eventType === FileProcessedEventType);

      const markFileAsConverted = (versionFile) => {
        versionFile.curTimer = "done";
        versionFile.converting = false;
      }
      
      const updateFilesAfterConversion = (versionFile) => {
        const convertedFile = fileConversionProofEvents.find((each) => each.appEventObject.file.id === versionFile.id);

        if (convertedFile) {
          markFileAsConverted(versionFile);
          versionFile.convertedFileKey = _.get(convertedFile, 'appEventObject.file.convertedFileKey', '');
          versionFile.conversionJobCompletedAt = _.get(convertedFile, 'appEventObject.file.conversionJobCompletedAt', null);
        } else if (versionFile.conversionJobCompletedAt !== null && versionFile.conversionJobCompletedAt !== MIN_DATE_TIME) {
          // Handle existing file's conversion status, as they don't have FileProcessedEventType
          markFileAsConverted(versionFile);
        } else if (versionFile.conversionJobQueuedAt !== null && versionFile.conversionJobQueuedAt === MIN_DATE_TIME) {
          // Handle case where conversion job was queued at min date time
          versionFile.converting = false;
        } else {
          let t = self.$A.TimeSinceDateTime(versionFile.conversionJobQueuedAt);
          versionFile.curTimer = `${t.minutes}:${t.seconds}`;
          versionFile.conversionTimerMin = t.minutes;
          versionFile.converting = true;
        }
        updateCdnLinks(versionFile);
      };

      let curProofVersionFiles = proof.currentVersion.versionFiles
          ? proof.currentVersion.versionFiles : [];

      curProofVersionFiles.forEach(versionFile => {
        updateCdnLinks(versionFile);
        versionFile.startedLoading = 0;
        versionFile.zoom = 1;
        versionFile.zoomMode = 0;//0 is fill Height 1 is fill width
        versionFile.height = 0;
        versionFile.zoomHeight = 0;
        versionFile.rotation = 0;
        versionFile.width = 0;
        versionFile.zoomWidth = 0;
        versionFile.player = {
          curPlayerTime: 0
        };
        versionFile.pdf = {
          totalPages: 0,
          curPage: 0,
          pageToView: 1
        };
        versionFile.element = null;
        versionFile.loaded = versionFile.loaded || false;
        // Inline text proof files (docx, txt) use originalFileKey directly — no conversion
        const isInlineProof = (versionFile.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && !versionFile.convertedMimeType && !versionFile.convertedFileKey)
            || versionFile.mimeType === 'text/plain';
        versionFile.src = (!versionFile.conversionJobQueuedAt || isInlineProof) ? versionFile.originalFileKey : versionFile.convertedFileKey;
        versionFile.conversionTimerMin = 0;
        versionFile.curTimer = '';
        updateFilesAfterConversion(versionFile);
      })

      //set active proof
      this.proof = proof;

      this.$emit("proofLoaded", proof);
      this.$emit("version-changed", proof.currentProofVersionId);

      //set colors
      if (_.get(this.proof, 'currentVersion.currentStage.approvers')) {
        this.proof.currentVersion.currentStage.approvers.forEach(function (a) {
          if (a.color === undefined) {
            a.color = self.getColor(a.id);
          }

          if (self.curApprover !== null && self.curApprover.id === a.id) {
            self.curApprover.color = a.color;
          }
        });
        this.proof.currentVersion.currentStage.reviewers.forEach(function (a) {
          if (a.color === undefined) {
            a.color = self.getColor(a.id);
          }

          if (self.curApprover !== null && self.curApprover.id === a.id) {
            self.curApprover.color = a.color;
          }
        });
      }

      if (_.get(this.proof, 'currentVersion.sender')) {
        this.proof.currentVersion.sender.color = self.getColor(this.proof.currentVersion.sender.id);
      }

      if (this.curUser !== null && this.curUser.color === undefined) {
        this.curUser.color = self.getColor(this.curUser.id);
      }

      if (this.curApprover !== null && this.curApprover.color === undefined) {
        // this is only used when the approver has not been added to the list yet
        this.curApprover.color = self.curApprover.id;
      }

      if (this.proof !== null && this.proof.engagedUsers) {
        let curUserInListYet = false;
        this.proof.engagedUsers.forEach(function (a) {
          if (self.curUser !== null ? self.curUser.id === a.id : false) {
            curUserInListYet = true;
          }
          if (a.color === undefined) {
            a.color = self.getColor(a.id);
          }
        });

        if (!curUserInListYet && this.curUser !== null) {
          const name = _.get(self, 'curUser.name', '');
          const initials = name && name.match(/\b\w/g).join("");

          this.proof.engagedUsers.push({
            id: _.get(self, 'curUser.id', ''),
            name: name,
            initials: initials || "",
            color: _.get(self, 'curUser.color', ''),
          });
        }
      }

      //save current proof version id
      let defaultFileIdToSelect = this.$A.LoadDataCache("proof_version_id:" + this.curVersionId + "_fileId");

      let viewedFiles = this.$A.LoadDataCache("proof_version_id:" + this.curVersionId + "_viewed_files") || [];

      this.proof.currentVersion.versionFiles.forEach(f => {
        f.viewed = viewedFiles.indexOf(f.id) > -1;
      });

      //load id from link
      if (this.$route.query.pfid &&
          this.$route.query.pfid > 0 &&
          this.proof.currentVersion.versionFiles.find(
              (f) => f.id === this.$route.query.pfid
          ) !== undefined
      ) {
        defaultFileIdToSelect = this.$route.query.pfid;
      }

      if (loadFile) {
        let a = this.proof.currentVersion.versionFiles.find(i => i.id === defaultFileIdToSelect);
        if (a) {
          this.reviewFile(a);
        } else if (this.proof.currentVersion.versionFiles.length > 0) {
          this.reviewFile(this.proof.currentVersion.versionFiles[0]);
        }
      }

      this.loadTourLabels();
    },
    GoToNextProofFile() {
      if (this.proof && this.proof.currentVersion) {
        let curIndex = this.files.indexOf(this.curFile);
        curIndex++;
        if (this.files[curIndex]) {
          this.reviewFile(this.files[curIndex]);
        }
      }
    },
    GoToPreviousProofFile() {
      if (this.proof && this.proof.currentVersion) {
        let curIndex = this.files
            .indexOf(this.curFile)
        curIndex--;
        if (this.files[curIndex]) {
          this.reviewFile(this.files[curIndex]);
        }
      }
    },
    GoToPage(goToPageInputValue) {
      let newPageNumber = parseInt(goToPageInputValue);
      if (newPageNumber > 0 && newPageNumber <= this.curFile.pdf.totalPages) {
        this.$refs.proofCanvas.resetDrawing();
        this.$refs.proofCanvas.resetFilePositions();
        this.curFile.pdf.pageToView = newPageNumber;
        let d = document.getElementById(`${this.label}-review-container`);
        if (d.length > 0) {
          d[0].scrollTo(0, 0);
        }
      }
    },
    GoToNextPage() {
      this.$refs.proofCanvas.resetDrawing();
      this.$refs.proofCanvas.resetFilePositions();
      if ((this.curFile.pdf.pageToView + 1) <= this.curFile.pdf.totalPages) {
        this.curFile.pdf.pageToView = this.curFile.pdf.pageToView + 1;
      }
      let d = document.getElementById(`${this.label}-review-container`);
      if (d.length > 0) {
        d[0].scrollTo(0, 0);
      }
    },
    GoToPreviousPage() {
      this.$refs.proofCanvas.resetDrawing();
      this.$refs.proofCanvas.resetFilePositions();
      (this.curFile.pdf.pageToView > 1) ? this.curFile.pdf.pageToView-- : true;
      let d = document.getElementById(`${this.label}-review-container`);
      if (d.length > 0) {
        d[0].scrollTo(0, 0);
      }
    },
    getLabel: function (section, key) {
      return this.$A.LangService.getLabel(section, key);
    },
    resize: function () {
      const proofCanvas = _.get(this.$refs, 'proofCanvas');

      if (proofCanvas && typeof proofCanvas.resize === FUNCTION) proofCanvas.resize();
    },
    updateZoom: function (zoomLevel) {
      this.$refs.proofCanvas.updateZoom(zoomLevel);
    },
    rotate: function () {
      this.$refs.proofCanvas.rotate();
    },
    setRotation: function (rotation) {
      this.$refs.proofCanvas.setRotation(rotation);
    },
    toggleZoomMode: function () {
      this.$refs.proofCanvas.toggleZoomMode();
    },
    setZoomMode: function (mode) {
      this.$refs.proofCanvas.setZoomMode(mode);
    },
    validateCanComment: function () {
      if (this.archived) {
        this.$A.AlertUser("The Proof Is Archived, No Changes Can Be Made.");
        return false;
      }

      if (this.proof.blockCommentingAfterProofDecision && this.approverFeedback !== null) {
        this.$A.AlertUser(`${this.getLabel('approver_decision_modal_labels', 'approver_alert_after_submit')}`);
        return false;
      }

      return true;
    },
    editComment: function (a, c) {
      if (!this.validateCanComment()) return;
      this.editingCommentId = c.id;
      this.menu = true;
      let self = this;
      this.$nextTick().then(function () {
        let refs = self.$refs["editing_comment_redactor" + c.id];
        if (refs) {
          let redactorRef = refs[0];
          setTimeout(() => {
            redactorRef.setFocusEnd();
            redactorRef.setTextBody(c.text);
          }, 200);
        }
      });
    },
    updateComment: async function (c, newText) {
      if (!this.validateCanComment()) return;
      c.text = newText;
      let commentUpdated = await this.$A.AnnotationService.UpdateComment(c) || {};
      if (!_.isEmpty(commentUpdated) && commentUpdated.id > 0) {
        c = commentUpdated;
        this.editingCommentId = 0;
      }
    },
    deleteAnnotation: async function (a) {
      if (!this.validateCanComment()) return;
      if (!Number.isInteger(a.id)) {
        this.curFile.proofFileAnnotations.splice(this.curAnnotations.indexOf(a), 1);
        return;
      }
      let response = await this.$A.AnnotationService.DeleteAnnotation(a.id);
      if (response && response.success) {
        this.curFile.proofFileAnnotations.splice(this.curAnnotations.indexOf(a), 1);
      }
    },
    addAnnotation: function (a) {
      if (!this.validateCanComment()) return false;
      this.curFile.proofFileAnnotations.push(a);
      this.menu = true;
      return true;
    },
    deleteComment: async function (a, c) {
      if (!this.validateCanComment()) return;
      let response = await this.$A.AnnotationService.DeleteComment(c.id);
      if (response && response.success) {
        a.proofFileAnnotationComments.splice(
            a.proofFileAnnotationComments.indexOf(c),
            1
        );
        if (
            a.proofFileAnnotationComments.length === 0 ||
            a.proofFileAnnotationComments === null ||
            a.proofFileAnnotationComments === undefined
        ) {
          await this.deleteAnnotation(a);
        }
      }
    },
    getTimeFormatFromSeconds(t) {
      return new Date(t * 1000).toISOString().substr(11, 8);
    },
    rotateImage: async function (srcBase64, degrees) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const image = new Image();

      image.src = srcBase64;
      await image.decode();

      canvas.width = degrees % 180 === 0 ? image.width : image.height;
      canvas.height = degrees % 180 === 0 ? image.height : image.width;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(degrees * Math.PI / 180);
      ctx.drawImage(image, image.width / -2, image.height / -2);

      return canvas.toDataURL();
    },
    addNewCommentToAnnotationThread: async function (a, text) {
      if (!this.validateCanComment()) return;
      if (
          a.proofFileAnnotationComments === undefined ||
          a.proofFileAnnotationComments === null ||
          a.proofFileAnnotationComments.length === 0
      ) {
        if (this.curAnnotationType.type === DRAW) {
          const drawImage = this.$refs.proofCanvas.getDrawToolImage();
          if (!drawImage) {
            this.$A.AlertUser("You are creating a drawing comment but nothing has been drawn yet.");
            return;
          }

          const degrees = 360 - this.curFile.rotation;
          const rotatedImage = await this.rotateImage(drawImage, degrees);
          // console.log("original", drawImage);
          // console.log('rotated', rotatedImage);
          a.drawingLayerImageBase64Encoded = rotatedImage;
          a.contextImageBase64Encoded = rotatedImage;
        } else {
          a.drawingLayerImageBase64Encoded = "";
        }

        if (!a.contextImageBase64Encoded) {
          a.contextImageBase64Encoded = "";
        }

        // debugger
        let annotationCreated = await this.$A.AnnotationService.CreateAnnotation(a);


        if (annotationCreated && annotationCreated.id > 0) {
          if (annotationCreated.proofFileAnnotationComments === null) {
            annotationCreated.proofFileAnnotationComments = [];
          }
          a.id = annotationCreated.id;
          a.drawingLayerImageUrl = annotationCreated.drawingLayerImageUrl;
          this.editingAnnotationId = a.id;
        }
      }

      if (Number.isNaN(a.id)) {
        this.$A.AlertUser(this.$A.ReviewService.Lang("error-save-comment-later"));
        return;
      }

      a.proofFileAnnotationComments = a.proofFileAnnotationComments || [];
      if (a.proofFileAnnotationComments.length === 0 && a.curTime > 0) {
        text = "@" + this.getTimeFormatFromSeconds(a.curTime) + " \n" + text;
      }

      let newComment = {
        id: this.$A.GetUUID(),
        proofAnnotationId: a.id,
        proofId: a.proofId,
        proofVersionId: a.proofVersionId,
        proofFileId: a.proofFileId,
        userId: _.get(this.curUser, "id", 0),
        approverId: _.get(this.curApprover, "id", 0),
        ownerName: _.get(this.curApprover, "name", "") || _.get(this.curUser, "name", ""),
        ownerInitials: _.get(this.curApprover, "initials", "") || _.get(this.curUser, "initials", ""),
        createdAt: new Date(),
        text: text,
        drawingLayerImageBase64Encoded: ""
      };

      let savedComment = await this.$A.AnnotationService.CreateComment(
          newComment
      );

      if (savedComment !== null && savedComment.id > 0) {
        a.proofFileAnnotationComments.push(savedComment);
      } else {
        this.$A.AlertUser("Error Encountered, Please Save This Comment Later.");
      }

      this.$refs.proofCanvas.resetDrawing();
    },
    downloadThisFile: function () {
      let self = this;
      if (self.curFile === undefined || self.isLiveProofView) {
        return;
      }
      let file = self.curFile;
      if (this.curApprover && this.curApprover.token !== undefined) {
        this.$A.ProofFileService.DownloadSingle(
            this.publicId,
            this.curVersionId,
            file.id,
            0,
            this.curApprover.token,
            name
        );
      }
      if (this.curUser && this.curUser.apiToken !== undefined) {
        this.$A.ProofFileService.DownloadSingle(
            this.publicId,
            this.curVersionId,
            file.id,
            this.curUser.apiToken.token,
            "",
            name
        );
      }
    },
    downloadAllFiles: function () {
      if (this.proof === null) {
        return;
      }
      let name =
          this.proof.name +
          "_" +
          this.currentProofVersion +
          ".zip";
      if (this.curApprover && this.curApprover.token !== undefined) {
        this.$A.ProofFileService.DownloadAll(
            this.publicId,
            this.curVersionId,
            0,
            this.curApprover.token,
            name
        );
      }
      if (this.curUser && this.curUser.apiToken !== undefined) {
        this.$A.ProofFileService.DownloadAll(
            this.publicId,
            this.curVersionId,
            this.curUser.apiToken.token,
            "",
            name
        );
      }
    },
    disableContextMenu: function () {
      let self = this;
      let interval = setInterval(() => {
        if (self.$refs.reviewContainer) {
          self.$refs.reviewContainer.addEventListener("contextmenu", function (evt) {
            evt.preventDefault();
            return false;
          });
          clearInterval(interval);
        }
      }, 50);
    },
    refreshIsSmallMobile: function () {
      this.isSmallMobileView = window.innerWidth < 576;
    },
    handleResizeWindow: function () {
      this.width = window.innerWidth > 0 ? window.innerWidth : screen.width;
      this.menu = this.width < 1200 && this.width > 992 ? false : true;
      this.refreshIsSmallMobile();
    },
    setRecording: function (status) {
      this.isRecording = status;
    },
    reviewFile: function (file) {
      // Deactivate any active comment when switching files
      if (this.editingAnnotationId !== 0) {
        this.setEditingAnnotationId(0);
      }
      
      const proofCanvas = _.get(this, '$refs.proofCanvas', null);
      if (proofCanvas && proofCanvas.reviewFile(file)) {
        //set the currently active file
        this.files.forEach(function (i) {
          if (i.id === file.id) {
            i.active = true;
            i.viewed = true;
          } else {
            i.active = false;
          }
        });
        // cache viewed files
        const viewed = this.files.filter(f => f.viewed).map(f => f.id);
        this.$A.SaveDataCache("proof_version_id:" + this.curVersionId + "_viewed_files", viewed);

        let self = this;
        this.$nextTick(() => {
          self.curFile = file;
          self.$nextTick(() => {
            const canvasElement = document.querySelector('.canvas-container');
            if (canvasElement) {
              self.$refs.proofCanvas.updateOnFileChanged();
            }
          });
        });
      }
    },
    goToLatestVersion: function () {
      if (this.latestVersionId) this.viewProofVersion(this.latestVersionId);
    },
    setCurAnnotationType: function (annoType) {
      this.curAnnotationType = annoType;
      this.isDragEnabled = false;
    },
    // Applies the account-level default annotation tool when the viewer lands on a
    // file whose type differs from the previous one; a tool picked manually is kept
    // while switching between files of the same type.
    applyDefaultAnnotationTool: function (file, prevFile) {
      if (!file || this.isMobile) return;
      if (prevFile && prevFile.docTypeGroup === file.docTypeGroup) return;
      if (file.docTypeGroup === AUDIO || this.isInlineTextProof) return;
      const toolType = _.get(
        this.accountDefaultAnnotationTools,
        annotationToolKeyForDocType(file.docTypeGroup)
      );
      if (!toolType || toolType === this.curAnnotationType.type) return;
      const tool = getAnnotationToolTypes(this.getLabel).find(t => t.type === toolType);
      if (tool) this.setCurAnnotationType(tool);
    },
    toggleMenu: function () {
      this.menu = !this.menu;
      this.$nextTick(this.resize);
    },
    handleProofNavHeight: function (height) {
      this.proofNavHeight = height;
    },
    handleProofToolsHeight: function (height) {
      this.proofToolsHeight = height;
    },
    handleProofCommentsWidth: function (width) {
      this.proofCommentsWidth = width;
    },
    handleProofFilesWidth: function (width) {
      this.proofFilesWidth = width;
    },
    setEditingAnnotationId: function (id) {
      this.setActiveEditorAnnotationId(0);
      this.editingAnnotationId = id;
      this.menu = true;
      this.$refs.proofComments.showComments();
    },
    setActiveEditorAnnotationId: function (id) {
      this.activeEditorAnnotationId = id;
    },
    viewAnnotation: function (a) {
      this.$refs.proofCanvas.viewAnnotation({annotation: a, toggle: true, fromSidebar: true});
    },
    scrollToTextHighlight: function (annotationId) {
      const canvas = this.$refs.proofCanvas;
      if (!canvas) return;
      // Try DocxViewer first, then TxtViewer
      const docxRef = canvas.$refs[`docx_viewer_${this.curFileId}`];
      const txtRef = canvas.$refs[`txt_viewer_${this.curFileId}`];
      const viewer = (docxRef && docxRef[0]) || (txtRef && txtRef[0]);
      if (viewer && viewer.scrollToAnnotation) {
        viewer.scrollToAnnotation(annotationId);
      }
    },
    deactivateComment: async function () {
      // Check if current editing annotation has no comments and delete it
      if (this.editingAnnotationId !== 0) {
        const currentAnnotation = this.curAnnotations.find(a => a.id === this.editingAnnotationId);
        if (currentAnnotation && 
            (!currentAnnotation.proofFileAnnotationComments || 
             currentAnnotation.proofFileAnnotationComments.length === 0)) {
          // Delete the empty annotation
          await this.deleteAnnotation(currentAnnotation);
        }
      }
      
      this.setEditingAnnotationId(0);
    },
    setLiveProofView: function (values) {
      this.isLiveProofView = values.isLiveProofView;
      this.liveProofActiveUrl = values.liveProofActiveUrl;
    },
    setLiveProofSizeSelected: function (size) {
      this.liveProofSizeSelected = size;
      this.$refs.proofCanvas.updateLiveProofSize();
    },
    toggleLiveProofCommentsEnabled: function () {
      this.liveProofCommentsEnabled = !this.liveProofCommentsEnabled;
    },
    setMobileStatus: function () {
      if (window.innerWidth < 991) { //mobile
        this.isMobile = true;
        this.isThirdWheelZoomActive = true;
        this.curAnnotationType = {
          docTypes: [DOCUMENT, VIDEO, IMAGE, HTML],
          type: POINT,
          title: () => this.$A.ReviewService.Lang("anno-single-click"),
          image: "/img/icon-doubleclick.svg",
          cursor: "/img/icon-doubleclick.png",
        };
      } else { // desktop
        this.isMobile = false;
        this.isThirdWheelZoomActive = false;
      }
    },
    handleColorPicker: function (color) {
      this.colorPickerColor = color;
    },
    handleUndoDrawing: function () {
      this.$refs.proofCanvas.undoDrawing();
    },
    handleResetDrawing: function () {
      this.$refs.proofCanvas.resetDrawing();
    },
    handleDrawToolLineWidth: function (width) {
      this.drawToolLineWidth = width;
    },
    handleViewComments: function (viewComments) {
      this.$refs.proofCanvas.setViewComments(viewComments);
    },
    followApprover: function(approver) {
      const sameApprover = (approver.approverType && this.currentApprover && approver.id === this.currentApprover.id);
      const sameUser = (!approver.approverType && this.currentUser && approver.id === this.currentUser.id);
      if (sameApprover || sameUser) {
        return this.stopFollowingApprover();
      }
      const curAnnotation = this.$refs.proofCanvas.getEditingAnnotation();
      if (curAnnotation) {
        this.$refs.proofCanvas.setEditingAnnotation(curAnnotation, true);
      }
      this.followingApprover = approver;
      this.followingTargetId = approver.approverType ? `a:${approver.id}` : `u:${approver.id}`;
    },
    stopFollowingApprover: function() {
      this.followingApprover = null;
      this.followingTargetId = null;
    },
    moveToFollowingApprover: function(steps, waitLoops) {
      let self = this;

      if (waitLoops) {
        waitLoops--;
        this.$nextTick(() => {
          self.moveToFollowingApprover(steps, waitLoops);
        });
      }

      if (steps.version) {
        this.viewProofVersion(steps.version).then(() => {
          delete steps.version;
          self.moveToFollowingApprover(steps, 2);
        });
      } else if (steps.file) {
        self.reviewFile(steps.file);
        delete steps.file;
        self.moveToFollowingApprover(steps, 5);
      } else if (steps.page) {
        self.GoToPage(steps.page);
        delete steps.page;
        self.moveToFollowingApprover(steps, 1);
      } else if(steps.zoom) {
        self.updateZoom(steps.zoom);
        delete steps.zoom;
        self.moveToFollowingApprover(steps, 1);
      } else if (steps.zoomMode) {
        self.setZoomMode(steps.zoomMode);
        delete steps.zoomMode;
        self.moveToFollowingApprover(steps, 1);
      } else if (steps.rotation !== undefined) {
        self.setRotation(steps.rotation);
        delete steps.rotation;
        // self.moveToFollowingApprover(steps, 1);
      }
    },
    toggleDragMode: function(action) {
      this.isDragEnabled = action === RESET ? false : !this.isDragEnabled;
    },
    // Temporary change-tracking highlight: draws a pulsing rectangle over the
    // current page image from 0-1 percentage coords. Anchored to the page
    // image's client rect (position: fixed) rather than a DOM wrapper — the
    // canvas moves the image with transforms/drag, so the client rect is the
    // only anchor that stays correct across zoom modes. Trade-off: the box
    // does not follow scroll/zoom during its ~4s lifetime. At fit-page zoom
    // this pulse is the only "where to look" signal, so tiny regions are
    // expanded symmetrically to a ~14px minimum and the highlight runs two
    // opacity pulses before fading out.
    flashChangeHighlight: function (box) {
      if (!box || !this.curFileId) return;
      const canvas = _.get(this, '$refs.proofCanvas', null);
      if (!canvas) return;
      const imgRefs = canvas.$refs['image_id_' + this.curFileId];
      const img = Array.isArray(imgRefs) ? imgRefs[0] : imgRefs;
      if (!img) return;
      // Anchor the pulse inside the image's positioned container so it
      // tracks the artwork through scrolling and panning (a body-fixed
      // overlay stays glued to the viewport). Positioning is derived from
      // getBoundingClientRect — which includes the rotate transform the
      // canvas applies to rotated files — with the region fractions mapped
      // through the same axis swap the rotation implies. Note: real
      // annotations live in annotationsLayer, which has its own rotation
      // matrix; this transient pulse mirrors that math locally.
      const host = img.offsetParent || img.parentElement;
      if (!host || !img.offsetWidth || !img.offsetHeight) return;
      const prior = host.querySelector('.change-flash-highlight');
      if (prior) prior.parentNode.removeChild(prior);
      const rect = img.getBoundingClientRect();
      const hostRect = host.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const rotation = (_.get(this, 'curFile.rotation', 0) || 0) % 360;
      // map the region (fractions of the unrotated page raster) into the
      // rotated visual space: 90° swaps axes clockwise, 270° counter-
      // clockwise, 180° flips both
      let fx = box.x;
      let fy = box.y;
      let fw = box.w;
      let fh = box.h;
      if (rotation === 90) {
        fx = 1 - box.y - box.h;
        fy = box.x;
        fw = box.h;
        fh = box.w;
      } else if (rotation === 180) {
        fx = 1 - box.x - box.w;
        fy = 1 - box.y - box.h;
      } else if (rotation === 270) {
        fx = box.y;
        fy = 1 - box.x - box.w;
        fw = box.h;
        fh = box.w;
      }
      let left = rect.left - hostRect.left + host.scrollLeft + fx * rect.width;
      let top = rect.top - hostRect.top + host.scrollTop + fy * rect.height;
      let w = fw * rect.width;
      let h = fh * rect.height;
      const minSize = 14;
      if (w < minSize) {
        left -= (minSize - w) / 2;
        w = minSize;
      }
      if (h < minSize) {
        top -= (minSize - h) / 2;
        h = minSize;
      }
      const el = document.createElement('div');
      el.className = 'change-flash-highlight';
      // styled after annotationsLayer's RECT annotations (4px solid border)
      el.style.cssText = [
        'position: absolute',
        'left: ' + left + 'px',
        'top: ' + top + 'px',
        'width: ' + w + 'px',
        'height: ' + h + 'px',
        'border: 4px solid #D44D68',
        'box-shadow: 0 0 0 2px rgba(212, 77, 104, 0.25)',
        'background-color: transparent',
        'pointer-events: none',
        'z-index: 99999',
        'opacity: 1'
      ].join(';');
      host.appendChild(el);
      // two attention pulses, then fade out (~4s total)
      if (el.animate) {
        el.animate(
          [
            { opacity: 1 },
            { opacity: 0.15 },
            { opacity: 1 },
            { opacity: 0.15 },
            { opacity: 1 },
            { opacity: 0 }
          ],
          { duration: 4000, easing: 'ease-in-out', fill: 'forwards' }
        );
      } else {
        el.style.transition = 'opacity 1s ease 3s';
        requestAnimationFrame(function () {
          el.style.opacity = '0';
        });
      }
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 4200);
    },
    // Fits the ENTIRE current page inside the pane's scroll viewport so a
    // navigated-to change is always shown with full page context — the
    // highlight pulse that follows is the "where to look" signal, and the
    // user zooms manually if they want detail. The scrollable viewport is
    // the `{label}-review-container` b-col (overflow: scroll); the page
    // image is laid out at curFile.zoomWidth x zoomHeight, both linear in
    // curFile.zoom, so the fit zoom is the min of the viewport/page ratios
    // at zoom 1 (with ~4% padding margin) applied through the same
    // updateZoom pathway the manual zoom controls use — nothing is locked,
    // manual zoom keeps working afterwards.
    fitPageOnRegion: async function (box) {
      if (!box || !this.curFile || !this.curFileId) return false;
      const canvas = _.get(this, '$refs.proofCanvas', null);
      const container = document.getElementById(`${this.label}-review-container`);
      if (!canvas || !container) return false;
      const imgRefs = canvas.$refs['image_id_' + this.curFileId];
      const img = Array.isArray(imgRefs) ? imgRefs[0] : imgRefs;
      if (!img) return false;
      // wait for the (possibly just page-swapped) image to finish loading —
      // its load handler resets zoom to fit (updateZoom(1)), so zooming
      // before it lands would be overwritten
      const startedAt = Date.now();
      while ((!img.complete || !img.naturalWidth) && Date.now() - startedAt < 5000) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      await new Promise((resolve) => setTimeout(resolve, 150));
      const viewportW = container.clientWidth;
      const viewportH = container.clientHeight;
      if (!viewportW || !viewportH) return false;
      // page size at zoom 1 under the current zoom mode (updateZoom scales
      // zoomWidth/zoomHeight linearly with the zoom level)
      const curZoom = this.curFile.zoom || 1;
      const baseW = (this.curFile.zoomWidth || 0) / curZoom;
      const baseH = (this.curFile.zoomHeight || 0) / curZoom;
      if (!baseW || !baseH) return false;
      const fitZoom = Math.min(viewportW / baseW, viewportH / baseH) * 0.96;
      this.updateZoom(fitZoom);
      await this.$nextTick();
      // let the layout settle before measuring the resized image
      await new Promise((resolve) => setTimeout(resolve, 150));
      const imgRect = img.getBoundingClientRect();
      const contRect = container.getBoundingClientRect();
      if (!imgRect.width || !imgRect.height) return false;
      const offsetLeft = imgRect.left - contRect.left + container.scrollLeft;
      const offsetTop = imgRect.top - contRect.top + container.scrollTop;
      // instant (non-smooth) scroll so the whole page sits fully visible —
      // centered when smaller than the viewport — and the fixed-position
      // highlight flash that follows anchors to the settled layout
      container.scrollTo(
        Math.max(0, offsetLeft - (viewportW - imgRect.width) / 2),
        Math.max(0, offsetTop - (viewportH - imgRect.height) / 2)
      );
      return true;
    },
  },
  computed: {
    tourSteps: function () {
      let self = this;
      return this.steps.filter((step, idx) => {
        if (step.disableIfSingleFile && self.files && self.files.length === 1) {
          return false;
        }
        if (step.disableOnFileTypes && self.curFile && step.disableOnFileTypes.includes(self.curFile.docTypeGroup)) {
          return false;
        }
        if (step.disableOnModes && step.disableOnModes.includes(self.mode)) {
          return false;
        }
        return true;
      }).map(step => {
        if (step.label && !step.content) {
          step.content = self.getLabel('tour_labels', step.label);
        }
        return step;
      });
    },
    curUsersTaggable: function () {
      let taggableUsers = [];
      let allApprovers = _.get(this.proof, 'currentVersion.stages', []).flatMap(stage => stage.approvers);
      let allReviewers = _.get(this.proof, 'currentVersion.stages', []).flatMap(stage => stage.reviewers);

      const curUsers = _.get(this.proof, 'engagedUsers', []);
      const curUserId = _.get(this.curUser, 'id');
      const curSender = _.get(this.proof, 'currentVersion.sender');
      const curSenderId = _.get(curSender, 'id');
      const curApproverId = _.get(this.curApprover, 'id');

      const toAddUsers = [];
      // add current user
      if (this.curUser) toAddUsers.push(this.curUser);
      // add sender
      if (curSender && curSenderId !== curApproverId) toAddUsers.push(curSender);
      // add reviewers
      toAddUsers.push(...allReviewers.filter(a => a.id !== curApproverId));
      // add engaged users
      toAddUsers.push(...curUsers.filter(a => a.id !== curApproverId));

      const toAddApprovers = [];
      // add current approver
      if (this.curApprover) toAddApprovers.push(this.curApprover);
      // add approvers
      toAddApprovers.push(...allApprovers.filter(a => a.id !== curUserId));

      // lookup map for those ids already added as taggable users
      const added = {};

      // adds a new taggable user if not added already
      const addTaggable = (a, type) => {
        if (added[a.id]) return;
        taggableUsers.push({
          type,
          name: a.name,
          color: a.color || this.getColor(a.id),
          email: a.email,
          initials: a.initials,
          publicId: a.publicId,
          id: a.id,
        });
        added[a.id] = true;
      };

      // add users
      toAddUsers.forEach(a => addTaggable(a, 'user'));

      // add approvers
      toAddApprovers.forEach(a => addTaggable(a, 'approver'));

      return taggableUsers;
    },
    curReviewers: function () {
      return _.get(this.proof, 'currentVersion.currentStage.reviewers', []);
    },
    curApprovers: function () {
      return _.get(this.proof, 'currentVersion.currentStage.approvers', []);
    },
    curUsers: function () {
      return _.get(this.proof, 'engagedUsers', []);
    },
    files: function () {
      return _.get(this.proof, 'currentVersion.versionFiles', []);
    },
    versions: function () {
      return _.get(this.proof, 'versionIds', []);
    },
    curVersionId: function () {
      return _.get(this.proof, 'currentProofVersionId', 1);
    },
    curFileId: function() {
      return _.get(this.curFile, 'id');
    },
    currentProofVersion: function () {
      return _.get(this.proof, 'currentVersion.versionNumber', 1);
    },
    currentUser: function () {
      return !this.curUser ? {id: 0} : this.curUser;
    },
    currentApprover: function () {
      return (this.curApprover && this.curApprover === null) ? {id: 0} : this.curApprover;
    },
    curSender: function () {
      return this.proof &&
      this.proof.currentVersion &&
      this.proof.currentVersion.sender
          ? this.proof.currentVersion.sender
          : {};
    },
    isModalOpen: function () {
      let approverResponseModal = this.$parent.$refs.approverResponseModal;
      return approverResponseModal && approverResponseModal.visible;
    },
    curZoom: function () {
      return _.get(this.curFile, 'zoom');
    },
    curZoomMode: function () {
      return _.get(this.curFile, 'zoomMode');
    },
    spaceAboveCanvas: function () {
      return this.proofNavHeight + this.proofToolsHeight;
    },
    spaceOnSidesOfCanvas: function () {
      return this.proofFilesWidth +
          (this.menu ? this.proofCommentsWidth : 70);
    },
    curAnnotations: function () {
      return _.get(this.curFile, 'proofFileAnnotations', []).map((a, i) => {
        a.isExpanded = (!a.resolved);
        a.index = i + 1;
        return a;
      });
    },
    // compare mode renders the right sidebar below the canvas (below the
    // fold), so the active annotation's comment thread is re-hosted in a
    // floating panel over the pane — same annotation object and handlers as
    // the sidebar composer, only the placement differs
    editingAnnotation: function () {
      if (!this.editingAnnotationId) return null;
      return (
        this.curAnnotations.find((a) => a.id === this.editingAnnotationId) ||
        null
      );
    },
    showFloatingComposer: function () {
      return this.isCompareMode && !!this.editingAnnotation;
    },
    usersColor: function () {
      const colors = {};
      this.curUsers.forEach(u => {
        colors[u.id] = u.color
      });
      this.curApprovers.forEach(u => {
        colors[u.id] = u.color
      });
      this.curReviewers.forEach(u => {
        colors[u.id] = u.color
      });
      this.curUsersTaggable.forEach(u => {
        colors[u.id] = u.color
      });

      if (this.curUser) colors[this.curUser.id] = this.curUser.color || this.getColor(this.curUser.id)
      if (this.curApprover) colors[this.curApprover.id] = this.curApprover.color || this.getColor(this.curApprover.id);

      return colors;
    },
    archived: function () {
      return _.get(this.proof, 'archived', false);
    },
    allowApproveWithChanges: function () {
      return _.get(this.proof, 'allowApproveWithChanges', false);
    },
    allowApproveIndividualFiles: function () {
      return _.get(this.proof, 'allowApproveIndividualFiles', false);
    },
    allowViewAllComments: function () {
      return _.get(this.proof, 'allowViewAllComments', false);
    },
    allowDownload: function () {
      return this.mode === PROOF_OWNER_MODE || _.get(this, 'proof.allowDownload', false);
    },
    showVertical() {
      return this.isCompareMode || this.isMobile;
    },
    isAudioFile() {
      return this.curFile && this.curFile.docTypeGroup === AUDIO;
    },
    isVideoFile() {
      return this.curFile && this.curFile.docTypeGroup === VIDEO;
    },
    isDragableFile() {
      return this.curFile && this.curFile.docTypeGroup !== VIDEO && this.curFile.docTypeGroup !== AUDIO && !this.isInlineTextProof;
    },
    isInlineTextProof() {
      if (!this.curFile || !this.curFile.mimeType) return false;
      const isDocx = this.curFile.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      const isTxt = this.curFile.mimeType === 'text/plain';
      if (isTxt) return true;
      if (isDocx && !this.curFile.convertedMimeType && !this.curFile.convertedFileKey && (!this.curFile.pdfExtractedJpgPages || this.curFile.pdfExtractedJpgPages.length === 0)) return true;
      return false;
    },
    showRotateTool() {
      return !this.isAudioFile && !this.isVideoFile && !this.isLiveProofView;
    },
    showZoomTools() {
      return !this.isAudioFile && !this.isLiveProofView;
    },
    curFileActiveUsers() {
      return _.get(this, 'actives', []).filter(u =>
          u.proofVersionId === this.curVersionId
          && u.proofFileId === this.curFileId
          && _.get(u, 'pageToView') === _.get(this.curFile, 'pdf.pageToView', -1)
      );
    },
    curFileEvents() {
      return _.get(this, 'events', []).filter(e => {
        return true;
      });
    },
    shouldHideFilesToReviewScreen() {
      return this.mode === PROOF_OWNER_MODE || this.files.length <= 1 || this.isCompareMode;
    },
    // versionIds arrives ordered by version number and new versions are
    // appended, so the newest is always last
    latestVersionId() {
      const versions = this.versions;
      if (!versions.length) return 0;
      return _.get(versions[versions.length - 1], 'proofVersionId', 0);
    },
    isViewingPreviousVersion() {
      if (this.versions.length < 2) return false;
      return !!this.latestVersionId && this.curVersionId !== this.latestVersionId;
    },
    accountDefaultAnnotationTools() {
      const raw = _.get(this.curAccount, "themeSettings.defaultAnnotationTools", null);
      if (!raw) return null;
      try {
        return typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (e) {
        return null;
      }
    }
  },
  watch: {
    // surface every current-file change (thumbnail clicks, version-change
    // defaults, programmatic switches) so the compare rail can follow along
    curFile: function (file, prevFile) {
      if (file) this.$emit("file-changed", file);
      this.applyDefaultAnnotationTool(file, prevFile);
    },
    shouldHideFilesToReviewScreen: {
      handler(newVal) {
        if (newVal) this.showFilesToReviewScreen = false;
        else this.showFilesToReviewScreen = true;
      },
      deep: true,
      immediate: true
    },
     files: {
      handler(newFiles) {
        this.showLeftSidebar = newFiles.length > 1;
        if (newFiles.length === 1) {
          this.$nextTick(() => {
            this.viewFile(newFiles[0]);
          });
        }
      },
      immediate: true,
      deep: true
    },
    actives: function (newVal) {
      if (this.followingTargetId) {
        const latest = newVal.find(u => u.targetId === this.followingTargetId);
        if (!latest) return;
        const steps = {};
        let move = false;

        if (latest.proofVersionId && this.curVersionId !== latest.proofVersionId) {
          steps.version = latest.proofVersionId;
          move = true;
        }
        if (latest.proofFileId && this.curFileId !== latest.proofFileId) {
          steps.file = this.files.find(f => f.id === latest.proofFileId);
          move = true;
        }
        const curPage = _.get(this.curFile, 'pdf.pageToView', -1);
        if (latest.pageToView && curPage !== latest.pageToView) {
          steps.page = latest.pageToView;
          move = true;
        }
        const curZoom = _.get(this.curFile, 'zoom');
        if (latest.zoom && curZoom !== latest.zoom) {
          steps.zoom = latest.zoom;
          move = true;
        }
        const curZoomMode = _.get(this.curFile, 'zoomMode');
        if (latest.zoomMode && curZoomMode !== latest.zoomMode) {
          steps.zoomMode = latest.zoomMode;
          move = true;
        }
        const rotation = _.get(this.curFile, 'rotation');
        if (rotation !== latest.rotation) {
          steps.rotation = latest.rotation;
          move = true;
        }
        if (move) {
          this.moveToFollowingApprover(steps);
        }
      }
    },
  }
};
</script>

<template>
  <div class="main-wrapper d-flex flex-column">
    <!-- accessDenied starts true while the approver identity loads; only a real
         denial sets a message, so gate on it to avoid flashing the dead-end state -->
    <div v-if="accessDenied && accessDeniedMessage" class="container-fluid" :style="{ height: '100%' }">
      <review-access-denied
          :message="accessDeniedMessage"
          :account-name="curAccount && curAccount.name ? curAccount.name : ''"
      />
    </div>
    <!-- proof-view-navigation -->
    <proof-view-navigation
        ref="proofNav"
        v-if="!accessDenied && isReviewMode"
        :disabled="!!followingApprover"
        :avatar="curLogo"
        :cur-version-id="curVersionId"
        :versions="versions"
        :approvers="curApprovers"
        :users="curUsers"
        :reviewers="curReviewers"
        :actives="actives"
        :cur-display-lang="curDisplayLang"
        :is-review-mode="isReviewMode"
        :is-mobile="isMobile"
        :approver-feedback="approverFeedback"
        :approver-skipped="approverSkipped"
        :archived="archived"
        :mode="mode"
        :show-approved-button="showApprovedButton"
        :allow-approve-with-changes="allowApproveWithChanges"
        :allow-approve-individual-files="allowApproveIndividualFiles"
        :display-all-approvers="allowViewAllComments"
        :allow-download="allowDownload"
        :is-viewing-previous-version="isViewingPreviousVersion"
        @on-go-to-latest-version="goToLatestVersion"
        @height-changed="handleProofNavHeight"
        @on-download-this-file="downloadThisFile"
        @on-download-all-files="downloadAllFiles"
        @on-version-change="viewProofVersion"
        @start-tour="$tours['review-screen'].start()"
        @follow-approver="followApprover"
        v-on="$listeners"
    />
    <files-to-review-screen v-if="!accessDenied && showFilesToReviewScreen" :files="files"
      :current-proof-version="currentProofVersion" :allow-approve-individual-files="allowApproveIndividualFiles"
      @view-file="viewFile" @approve-file="approveFile" @reject-file="rejectFile" :is-compare-mode="isCompareMode" :mode="mode" :approver-feedback="approverFeedback"
      :is-viewing-previous-version="isViewingPreviousVersion"/>
    <!-- File View -->
    <div v-if="!accessDenied && !showFilesToReviewScreen && files && files.length > 0"
        :class="{'' : showVertical, 'd-flex flex-fill  flex-lg-row flex-column ': !showVertical }"
        class="bg-light overflow-auto position-relative"
         @resize.window="handleResizeWindow" @init="handleResizeWindow">
      <!-- proof-view-side-bar-left -->
      <proof-view-side-bar-left
          :files="files"
          :active-file="curFile ? curFile : files[0]"
          @set-active-file="reviewFile"
          @width-changed="handleProofFilesWidth"
          :is-compare-mode="isCompareMode"
          :is-mobile="isMobile"
          :disabled="!!followingApprover"
          :change-tracking-summary="changeTrackingSummary"
          :should-hide-files-to-review-screen="shouldHideFilesToReviewScreen"
          v-if="(showLeftSidebar || this.isCompareMode) && files.length > 1"
          @show-files-to-review-screen="handleFilesToReviewScreenVisibility"
      />
      <!--  proof tools and canvas  -->
      <main :class="{'canvas-wrapper-compare' : isCompareMode, 'pl-73' : !showVertical && showLeftSidebar, 'overflow-hidden': !isInlineTextProof, 'overflow-auto': isInlineTextProof}"
            class="canvas-container canvas-wrapper flex-fill position-relative">
        <!-- proof-view-tools -->
        <proof-view-tools
            ref="proofTools"
            v-if="!isAudioFile && !followingApprover"
            :disabled="!!followingApprover"
            :cur-file="curFile"
            :is-mobile="isMobile"
            :is-compare-mode="isCompareMode"
            :cur-annotation-type="curAnnotationType"
            :set-cur-annotation-type="setCurAnnotationType"
            :cur-zoom="curZoom"
            :cur-zoom-mode="curZoomMode"
            :update-zoom="updateZoom"
            :rotate="rotate"
            :toggle-zoom-mode="toggleZoomMode"
            :go-to-next-page="GoToNextPage"
            :go-to-previous-page="GoToPreviousPage"
            :go-to-page="GoToPage"
            :is-live-proof-view="isLiveProofView"
            :live-proof-size-selected="liveProofSizeSelected"
            :live-proof-predefined-sizes="liveProofPredefinedSizes"
            :live-proof-comments-enabled="liveProofCommentsEnabled"
            :is-recording="isRecording"
            :show-zoom-tools="showZoomTools"
            :show-rotate-tool="showRotateTool"
            :toggle-drag-mode="toggleDragMode"
            :is-drag-enabled="isDragEnabled"
            :is-dragable-file="isDragableFile"
            :is-third-wheel-zoom-active="isThirdWheelZoomActive"
            :is-inline-text-proof="isInlineTextProof"
            :mode="mode"
            @height-changed="handleProofToolsHeight"
            @set-live-proof-size-selected="setLiveProofSizeSelected"
            @toggle-live-proof-comments="toggleLiveProofCommentsEnabled"
        />
        <!-- proof-view-canvas -->
        <proof-view-canvas
            ref="proofCanvas"
            id="review-canvas"
            :cur-version-id="curVersionId"
            :label="label"
            :space-above="spaceAboveCanvas"
            :space-on-sides="spaceOnSidesOfCanvas"
            :active-file="curFile ? curFile : files[0]"
            :files="files"
            :mode="mode"
            :viewMode="viewMode"
            :isReviewMode="isReviewMode"
            :isCompareMode="isCompareMode"
            :isMobile="isMobile"
            :curUser="curUser"
            :curUsers="curUsers"
            :active-users="curFileActiveUsers"
            :proof-active-users="actives"
            :events="curFileEvents"
            :curApprover="curApprover"
            :curApprovers="curApprovers"
            :curAccount="curAccount"
            :curReviewers="curReviewers"
            :is-modal-open="isModalOpen"
            :cur-annotation-type="curAnnotationType"
            :delete-annotation="deleteAnnotation"
            :add-annotation="addAnnotation"
            :cur-annotations="curAnnotations"
            :color-picker-color="colorPickerColor"
            :draw-tool-line-width="drawToolLineWidth"
            :live-proof-size-selected="liveProofSizeSelected"
            :live-proof-predefined-sizes="liveProofPredefinedSizes"
            :live-proof-comments-enabled="liveProofCommentsEnabled"
            :users-color="usersColor"
            :following-approver="followingApprover"
            :allow-view-all-comments="allowViewAllComments"
            :is-drag-enabled="isDragEnabled"
            :isThirdWheelZoomActive="isThirdWheelZoomActive"
            @reset-drag-mode="toggleDragMode"
            @on-recording="setRecording"
            @on-editing-annotation-id="setEditingAnnotationId"
            @on-live-proof-size-selected="setLiveProofSizeSelected"
            @on-live-proof-view="setLiveProofView"
            @set-mobile-status="setMobileStatus"
            @cursor-update="event => $emit('cursor-update', event)"
            @stop-following-approver="stopFollowingApprover"
            @on-load-proof-version="viewProofVersion"
        />
      </main>
      <!-- compare-mode floating composer: hosts the active annotation's
           comment thread over the pane (the sidebar below is out of view) -->
      <div v-if="showFloatingComposer"
           class="compare-floating-composer"
           :id="`${label}-floating-composer`"
      >
        <proof-view-comment
            :key="`${label}-float-${editingAnnotation.id}`"
            :label="`${label}-float`"
            :comment="editingAnnotation"
            :is-active="true"
            :cur-file="curFile"
            :cur-user="curUser"
            :cur-approver="curApprover"
            :cur-annotation-type="curAnnotationType"
            :cur-users-taggable="curUsersTaggable"
            :comment-file-api="commentFileApi"
            :is-live-proof-view="isLiveProofView"
            :live-proof-active-url="liveProofActiveUrl"
            :live-proof-size-selected="liveProofSizeSelected"
            :users-color="usersColor"
            :disabled="!!followingApprover"
            :allow-view-all-comments="allowViewAllComments"
            @on-save-comment="addNewCommentToAnnotationThread"
            @on-update-comment="updateComment"
            @on-delete-comment="deleteComment"
            @on-set-active-comment="viewAnnotation"
            @on-editor-show="setActiveEditorAnnotationId"
            @on-deactivate-comment="deactivateComment"
            @on-scroll-to-highlight="scrollToTextHighlight"
        />
      </div>
      <!-- proof-view-side-bar-right  -->
      <proof-view-side-bar-right ref="proofComments"
          :label="label"
          :disabled="!!followingApprover"
          :active-file="curFile"
          :cur-user="curUser"
          :cur-approver="curApprover"
          :menu="menu"
          :proof-view-version="proofViewVersion"
          :cur-annotations="curAnnotations"
          :cur-annotation-type="curAnnotationType"
          :active-comment-id="editingAnnotationId"
          :cur-users-taggable="curUsersTaggable"
          :comment-file-api="commentFileApi"
          :is-live-proof-view="isLiveProofView"
          :live-proof-active-url="liveProofActiveUrl"
          :live-proof-size-selected="liveProofSizeSelected"
          :is-compare-mode="isCompareMode"
          :is-mobile="isMobile"
          :users-color="usersColor"
          :avatar="curLogo"
          :cur-account="curAccount"
          :active-editor-annotation-id="activeEditorAnnotationId"
          :allow-view-all-comments="allowViewAllComments"
          :current-proof="proof"
          :change-tracking="changeTracking"
          @change-selected="$emit('change-selected', $event)"
          @compare-file-changes="$emit('change-badge-selected', $event)"
          @on-set-recording="setRecording"
          @on-toggle="toggleMenu"
          @on-width-changed="handleProofCommentsWidth"
          @on-save-comment="addNewCommentToAnnotationThread"
          @on-update-comment="updateComment"
          @on-delete-comment="deleteComment"
          @on-set-active-comment="viewAnnotation"
          @on-editor-show="setActiveEditorAnnotationId"
          @on-undo-drawing="handleUndoDrawing"
          @on-reset-drawing="handleResetDrawing"
          @on-draw-color-change="handleColorPicker"
          @on-draw-line-width-change="handleDrawToolLineWidth"
          @on-showing-comments="handleViewComments"
          @on-deactivate-comment="deactivateComment"
          @on-scroll-to-highlight="scrollToTextHighlight"
      />
    </div>
    <!--   tour   -->
    <v-tour v-if="isReviewMode && !isMobile"
        v-show="curFile && !showFilesToReviewScreen"
        name="review-screen"
        :steps="tourSteps"
        :callbacks="tourCallbacks"
        :options="{labels: tourLabels}"
    ></v-tour>
  </div>
</template>

<style scoped>
.canvas-wrapper-compare {
  margin: 0px !important;
  padding: 0px !important;
}
/* compare-mode floating composer panel (see showFloatingComposer) */
.compare-floating-composer {
  position: absolute;
  top: 56px;
  right: 12px;
  width: 320px;
  max-width: calc(100% - 24px);
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #ebebed;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  z-index: 3000;
}
.canvas-container{
  container-type: inline-size;
}
.pl-73 {
  padding-left: 73px;
}
@media(min-width:992px) {
  .main-wrapper{
    height: 100vh;
    background-color: white;
  }
}
@media(max-width:1200px) and (min-width:992px){
  .canvas-wrapper{
    margin-right: 72px;
  }
}
@media(max-width:992px){
  .canvas-wrapper{
    height: auto !important;
    display: flex !important;
    flex-direction: column !important;
  }
  .navbar-btn-container{
    width: 100%;
    border-right: 0px !important;
    border-top:  1px solid #EBEBED;
  }
}

</style>
